import { ImisResponseItems } from "../models/imis.models";
import { RestUtility } from "./rest.utility";

export class PartyUtility {

    public static async isUserStaffById(id: string): Promise<boolean> {
        let isStaff = false;

        // get username from id
        let userResponse = await RestUtility.restApiGetData<ImisResponseItems<any>>("/api/user", { userid: id });
        if (userResponse != null && userResponse.Items.length > 0) {
            let user = userResponse.Items[0];
            let username = user.UserName;
            
            let csStaffUserResponse = await RestUtility.restApiGetData<ImisResponseItems<any>>("/api/csstaffuser", { userid: username });
            if (csStaffUserResponse != null && csStaffUserResponse.Items.length > 0) {
                isStaff = true;
            }
        }

        return isStaff;
    }

}